import { createRouter, createWebHashHistory } from 'vue-router';
import routeHelp from "./routeHelp";
//路由去重
let duplicateRemoval = function (arr) {
    let children = [];
    arr.forEach((item) => {
        let _index = children.findIndex(i => { return i.name == item.name && i.path == item.path });
        if (_index < 0) {
            children.push(item);
        }
    });
    return children;
}
// import paths from './paths'
// let r1 = paths.find(item => item.name === "铁安通云平台");

// function setPageUrl(path, view, name, breadcrumb) {
//     return {
//         name: name,
//         path: path,
//         meta: {
//             title: name,
//             breadcrumb
//         },
//         component: (resovle) => import(`@views/${view}.vue`).then(resovle),
//     }
// }
let _routes = [
    {
        path: '/',
        redirect: '/index',
    },
    {
        path: '/',
        component: () => import('@views/Home.vue'),
        children: [
            {
                path: '/index',
                // name: '系统首页',
                component: () => import('@views/index.vue'),
                meta: {
                    title: '系统首页',
                    breadcrumb: {
                        id: "0"
                    },
                }
            },
            {
                name: "问卷中心",
                path: "/QuestionnaireEdit",
                meta: {
                    title: "问卷中心",
                    breadcrumb: {
                        id: "8-1"
                    }
                },
                component: (resovle) => import(`@views/QuestionnaireCenter/QuestionnaireEdit.vue`).then(resovle),
            },
            {
                name: "考试中心",
                path: "/ExamManagement",
                meta: {
                    title: "考试中心",
                    breadcrumb: {
                        id: "9-1"
                    }
                },
                component: (resovle) => import(`@views/YZExam/ExamManagement.vue`).then(resovle),
            },
            {
                name: "试卷中心",
                path: "/ExamManagementEdit",
                meta: {
                    title: "试卷中心",
                    breadcrumb: {
                        id: "9-2"
                    }
                },
                component: (resovle) => import(`@views/YZExam/ExamManagementEdit.vue`).then(resovle),
            },
            {
                name: "试卷管理",
                path: "/ExamEdit",
                meta: {
                    title: "试卷管理",
                    breadcrumb: {
                        id: "9-3"
                    }
                },
                component: (resovle) => import(`@views/YZExam/ExamEdit.vue`).then(resovle),
            },
            {
                name: "考试成绩报告详情",
                path: "/ExamDataCenterDetail",
                meta: {
                    title: "考试成绩报告详情",
                    breadcrumb: {
                        id: "9-4"
                    }
                },
                component: (resovle) => import(`@views/YZExam/ExamDataCenterDetail.vue`).then(resovle),
            },
            {
                name: "考试数据中心详情",
                path: "/ExamReportDetail",
                meta: {
                    title: "考试数据中心详情",
                    breadcrumb: {
                        id: "9-5"
                    }
                },
                component: (resovle) => import(`@views/YZExam/ExamReportDetail.vue`).then(resovle),
            },
            {
                name: "题库列表",
                path: "/QuestionBankEdit",
                meta: {
                    title: "题库列表",
                    breadcrumb: {
                        id: "3-1"
                    }
                },
                component: (resovle) => import(`@views/YZExam/QuestionBankEdit.vue`).then(resovle),
            },
            {
                name: "题库管理",
                path: "/QuestionBank",
                meta: {
                    title: "题库管理",
                    breadcrumb: {
                        id: "3-0"
                    }
                },
                component: (resovle) => import(`@views/YZExam/QuestionBank.vue`).then(resovle),
            },
            {
                name: "课程详情",
                path: "/CourseDetail",
                meta: {
                    title: "课程详情",
                    breadcrumb: {
                        id: "11-1"
                    }
                },
                component: (resovle) => import(`@views/CourseManagement/CourseDetail.vue`).then(resovle),
            }
            // ...r1.children.map(path => setPageUrl(path.path, path.view, path.name, path.breadcrumb)),
        ]
    },
    {
        path: '/studyLogin',
        name: 'StudyLogin',
        component: () => import('@views/StudyLogin.vue')
    },
    {
        path: '/login',
        name: 'Login',
        component: () => import('@views/Login.vue'),
        meta: { redirectAlreadyLogin: true }
    },
    {
        path: '/404',
        name: '404',
        component: () => import('@views/404.vue')
    },
    {
        path: '/:pathMatch(.*)*',
        redirect: '/index'
    },
]
/* 判断缓存是否存在存在直接加载到_routes中 */
let menuList = routeHelp.getMenu_cache();
if (menuList) {
    let bs_routes = routeHelp.formatRoutes(menuList);
    _routes[1].children = duplicateRemoval(_routes[1].children.concat(bs_routes));
}
/*********************/
const routerHistory = createWebHashHistory()
let router = createRouter({
    history: routerHistory,
    routes: _routes
})

//使用钩子函数对路由进行权限跳转
router.beforeEach((to, from, next) => {
    if (to.path == '/') return;
    let role = sessionStorage.getItem('UserID');
    if (!role && to.path !== '/login' && to.path !== '/studyLogin') {
        next('/login');
    } else if (to.meta.permission) {
        // 如果是管理员权限则可进入，这里只是简单的模拟管理员权限而已
        role === 'admin' ? next() : next('/403');
    } else {
        next();
    }
})

export default router;
